import React from "react";

export default function Confidentiality(props) {
  return (
    <div>
      <h1 className="text-3xl font-bold mb-6 text-yellow-500">
        Confidentiality
      </h1>

      <div className="space-y-5">
        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <span className="text-gray-700">
            The identity of the complainant, respondent, witnesses, any
            information relating to conciliation and inquiry proceedings,
            recommendations of the ICC / Inquiry Committee, and action taken by
            CEO,SS are considered as confidential material, and shall not be
            published or made known to public, press or media in any manner.
          </span>
        </div>
        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <span className="text-gray-700">
            Any person contravening the confidentiality clause shall be subject
            to disciplinary action as prescribed in the Sexual Harassment of
            Women at Workplace Act, 2013.
          </span>
        </div>
      </div>

      <hr className="border border-gray-300 my-[40px]"/>

      <div>
      <h1 className="text-3xl font-bold mb-6 text-yellow-500">Appeal</h1>

      <div className="space-y-5">
        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <span className="text-gray-700">
            Any party not satisfied or further aggrieved by the decision of the
            Inquiry Committee/ ICC or by the recommendations made by the ICC or
            the implementation or non-implementation of such recommendations,
            may prefer an appeal to the appellate authority in accordance with
            the Sexual Harassment of Women at Workplace Act, 2013, within 90
            days of the recommendations being communicated, wherever applicable.
          </span>
        </div>
      </div>
    </div>
    </div>
  );
}
